import React from 'react';
import CustomInput from '../../form/CustomInput';
import { FieldLabel } from './FieldSettingsModal';
import { useTheme } from '../../../middleware/ThemeContext';

export const DecimalPlacesSettings: React.FC<{
  decimalPlaces?: number;
  setDecimalPlaces: (value: number | undefined) => void;
}> = ({ decimalPlaces, setDecimalPlaces }) => {
  const { theme } = useTheme();

  const handleChange = (value: string) => {
    if (value === '') {
      setDecimalPlaces(4);
      return;
    }
    const n = Number(value);
    if (Number.isFinite(n) && n >= 1 && n <= 4) {
      setDecimalPlaces(Math.floor(n));
    }
  };

  return (
    <div className="px-3 py-2">
      <FieldLabel theme={theme}>Decimal Places</FieldLabel>
      <CustomInput
        type="number"
        value={decimalPlaces === undefined ? '4' : String(decimalPlaces)}
        onChange={handleChange}
        placeholder="Enter allowed decimal places"
        min={1}
        max={4}
        step="1"
      />
    </div>
  );
};
